import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssets = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#9ae981",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 2,
		width: 14,
		height: 12,
		rx: 1,
		fill: "currentColor",
		fillOpacity: .25,
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.70732 10.8093L6.48986 7.67274C6.61991 7.52614 6.82362 7.46903 7.01093 7.52667L9.56851 8.31361C9.7808 8.37893 10.0107 8.29638 10.133 8.11094L12.3548 4.74097",
		stroke: "currentColor",
		strokeLinecap: "round"
	})]
});
export default SvgAssets;
